import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'src/components/Link/Link';
import imgFallback from 'src/utils/image';
import { ProcessSwitch } from './ProcessSwitch';

export const Intro = ({ title, onActiveProcessIndexChange, processes, activeProcess }) => (
  <Row className="mb-xl-0 processes-intro mb-5">
    <Col xs={12} md={{ span: 9 }} lg={{ span: 6, offset: 0 }} xl={{ span: 5, offset: 0 }} className="z-index-1">
      {activeProcess.title && (
        <div className="d-flex align-items-baseline mb-4">
          <h2 className="mb-0 mr-3 text-white">{title}</h2>
          {activeProcess.icon && (
            <GatsbyImage
              image={activeProcess.icon?.image?.asset?.gatsbyImageData ?? imgFallback}
              alt={activeProcess.icon?.alt ?? ''}
              className="shadow-image d-flex"
            />
          )}
        </div>
      )}

      {processes.length > 1 && (
        <ProcessSwitch activeProcessIndex={activeProcess.index} onProcessIndexChange={onActiveProcessIndexChange} processes={processes} />
      )}

      <div className="text-white-75" dangerouslySetInnerHTML={{ __html: activeProcess.description }} />

      {activeProcess.link && <Link to={activeProcess.link.url} className={activeProcess.styles.buttonClass} />}
    </Col>
  </Row>
);
